import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { Globals, StyleReset } from '@bwoty-web/ui-kit';
import configureStore from './redux/store/lmsStore';

import MainContainer from './containers/MainContainer';
import { initLMSRequestSaga } from './redux/saga/initLmsRequestSaga';
import { filterRequestSaga } from './redux/saga/filterRequestSaga';
import { fetchMoreRequestSaga } from './redux/saga/fetchMoreRequestSaga';
import { sortRequestSaga } from './redux/saga/sortRequestSaga';

const initialState = window.__INITIAL_LASTMINUTESALES_STATE__; // eslint-disable-line
delete window.__INITIAL_LASTMINUTESALES_STATE__; // eslint-disable-line

const store = configureStore(initialState, [
  initLMSRequestSaga,
  filterRequestSaga,
  fetchMoreRequestSaga,
  sortRequestSaga,
]);
const siteId = store.getState()?.settings?.siteId;
const isStandalone = store.getState()?.settings?.isStandalone;

const currentPathName = initialState?.location?.pathname || '';
// TODO: Remove this when idun starts sending originalUrl to apps.
if (currentPathName && currentPathName.indexOf('/markup') === 0) {
  initialState.location.pathname = window.location.pathname;
}

const mountPoint = document.getElementById('lastminutesales');

hydrate(
  <Provider store={store}>
    <Globals siteId={siteId}>
      {isStandalone && <StyleReset />}
      <MainContainer appSettings={initialState.settings} />
    </Globals>
  </Provider>,
  mountPoint,
);

if (process.env.NODE_ENV !== 'production') {
  window.React = React; // enable debugger
}
